<template>
    <div class="c-standard-summary">
        <table :class="{ 'table-responsive': Core.Display.isMobile() }" class="table">
            <thead>
                <th>
                    {{Core.Definition.getDefinition('Produit')}}
                </th>
                <th width="140px"></th>
                <th width="150px">
                    {{Core.Definition.getDefinition('Prix')}}
                </th>
                <th width="100px">
                    {{Core.Definition.getDefinition('Total')}}
                </th>
                <th width="100px"></th>
                <th width="50px"></th>
            </thead>
            <tbody>
                <tr v-if="dataProducts.length === 0">
                    <td colspan="7">{{Core.Definition.getDefinition('Aucun produit à afficher')}}</td>
                </tr>

                <template v-for="product, productIndex in dataProducts">
                    <tr>
                        <td>
                            {{product.instance.title}}
                        </td>
                        <td>
                            <div v-if="Core.Product.participantModeIsEnabled(product.instance) === false">
                                <InputQuantity
                                        v-if="isNaN(quantityStep) && product.instance[quantityStep] !== undefined && !isNaN(product.instance[quantityStep])"
                                        @change="eval"
                                        :max="dataProducts[productIndex].instance.stockQuantity"
                                        :step="parseInt(product.instance[quantityStep])"
                                        v-model="dataProducts[productIndex].quantity">
                                </InputQuantity>
                                <InputQuantity
                                        v-else
                                        @change="eval"
                                        :step="quantityStep"
                                        v-model="dataProducts[productIndex].quantity">
                                </InputQuantity>
                            </div>
                            <span v-if="Core.Product.participantModeIsEnabled(product.instance) === true">1</span>
                            <div v-if="dataProducts[productIndex].instance.stockManagement == 1">
                                <small>{{Core.Text.format(Core.Definition.getDefinition('Disponible(s) {0}'), dataProducts[productIndex].instance.stockQuantity)}}</small>
                            </div>
                        </td>
                        <td>
                            <InputCurrency
                                    @change="eval"
                                    v-model="dataProducts[productIndex].instance.regularPrice">
                            </InputCurrency>
                        </td>
                        <td>
                            {{Core.Currency.format(dataProducts[productIndex].total)}}
                        </td>
                        <td>
                            <div v-if="product.instance.isTaxable">
                                + {{Core.Currency.format(dataProducts[productIndex].taxesTotal)}}
                                <p class="small" v-html="Core.Taxes.display(dataProducts[productIndex].taxes, true, '<br>')"></p>
                            </div>
                            <p v-else class="small">{{Core.Definition.getDefinition('Non taxable')}}</p>
                        </td>
                        <td>
                            <b-button @click="onTrashClick(productIndex)" class="btn btn-danger btn-sm"><i class="fa fa-trash-o"></i></b-button>
                        </td>
                    </tr>
                    <tr v-if="dataProducts[productIndex].data !== undefined&&dataProducts[productIndex].data.promoCode !== undefined&&dataProducts[productIndex].data.promoCode.code!==undefined">
                        <td class="text-right" colspan="4">
                            <b><i>{{dataProducts[productIndex].data.promoCode.code}}</i></b>
                        </td>
                        <td>
                            <i>- {{Core.Currency.format(dataProducts[productIndex].data.promoCode.deductible)}}</i>
                        </td>
                        <td width="100px"></td>
                        <td width="50px"></td>
                    </tr>
                    <tr v-if="Core.Product.participantModeIsEnabled(product.instance)||Core.Product.conditionalIsEnabled(product.instance)">
                        <td style="border-top: none; padding-top: 0px" colspan="7">
                            <b-button-group>
                                <b-button v-if="Core.Product.participantModeIsEnabled(product.instance)" v-b-toggle="'collapseParticipantMode' + productIndex" class="btn btn-sm btn-light">{{Core.Definition.getDefinition('Participant')}} <i class="fa fa-chevron-down"></i></b-button>
                                <b-button v-if="Core.Product.conditionalIsEnabled(product.instance)" v-b-toggle="'collapseConditionalIsEnabled' + productIndex" class="btn btn-sm btn-light">{{Core.Definition.getDefinition('Conditionnelles')}} <i class="fa fa-chevron-down"></i></b-button>
                                <b-button v-if="Core.Product.hasForm(product.instance)" v-b-toggle="'collapseForm' + productIndex" class="btn btn-sm btn-light">{{Core.Definition.getDefinition('Formulaire')}} <i class="fa fa-chevron-down"></i></b-button>
                            </b-button-group>
                        </td>
                    </tr>
                    <tr v-if="Core.Product.hasForm(product.instance)">
                        <td style="border-top: none" colspan="7">
                            <b-collapse :id="'collapseForm' + productIndex" class="mt-2">

                                <table width="100%">
                                    <tr v-for="meta in product.instance.form.meta">
                                        <td>{{meta.label}}</td>
                                        <td>{{meta.value}}</td>
                                    </tr>
                                </table>

                            </b-collapse>
                        </td>
                    </tr>
                    <tr v-if="Core.Product.participantModeIsEnabled(product.instance)">
                        <td style="border-top: none" colspan="7">
                            <b-collapse :id="'collapseParticipantMode' + productIndex" class="mt-2">

                                <b-row>
                                    <b-col>
                                        <InputText
                                                v-model="dataProducts[productIndex].data.participant.firstname"
                                                :label="Core.Definition.getDefinition('Prénom')">
                                        </InputText>
                                    </b-col>
                                    <b-col>
                                        <InputText
                                                v-model="dataProducts[productIndex].data.participant.lastname"
                                                :label="Core.Definition.getDefinition('Nom')">
                                        </InputText>
                                    </b-col>
                                    <b-col>
                                        <InputDatePicker
                                                v-model="dataProducts[productIndex].data.participant.birthdate"
                                                :label="Core.Definition.getDefinition('Date de naissance')">
                                        </InputDatePicker>
                                    </b-col>
                                    <b-col>
                                        <strong>{{Core.Definition.getDefinition('Date de naissance')}}</strong>
                                        {{Core.Definition.getDefinition('Jour')}}
                                        <b-select v-model="dataProducts[productIndex].data.participant.birthdateDay">
                                            <option v-for="i in 30" :value="i+1" >{{i+1}}</option>
                                        </b-select>
                                        {{Core.Definition.getDefinition('Mois')}}
                                        <b-select v-model="dataProducts[productIndex].data.participant.birthdateDay">
                                            <option v-for="i in 11" :value="i+1" >{{i+1}}</option>
                                        </b-select>
                                        {{Core.Definition.getDefinition('Année')}}
                                        <b-select v-model="dataProducts[productIndex].data.participant.birthdateDay">
                                            <option v-for="i in 100" :value="i+1930" >{{i+1930}}</option>
                                        </b-select>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <InputText
                                                v-model="dataProducts[productIndex].data.participant.urgencyContact"
                                                :label="Core.Definition.getDefinition('Urgence: Contact')">
                                        </InputText>
                                    </b-col>
                                    <b-col>
                                        <InputText
                                                v-model="dataProducts[productIndex].data.participant.urgencyPhone"
                                                :label="Core.Definition.getDefinition('Urgence: Téléphone')">
                                        </InputText>
                                    </b-col>
                                    <b-col>
                                        <InputText
                                                v-model="dataProducts[productIndex].data.participant.insuranceNumber"
                                                :label="Core.Definition.getDefinition('Num. assurance maladie')">
                                        </InputText>
                                    </b-col>
                                </b-row>

                                <b-row v-if="Core.Value.encode(Core.Session.Setting.getSetting('commerce.product.teamIsEnabled'), 'checkbox') || Core.Value.encode(Core.Session.Setting.getSetting('commerce.product.participantCategoryIsEnabled'), 'checkbox')">
                                    <b-col v-if="Core.Value.encode(Core.Session.Setting.getSetting('commerce.product.teamIsEnabled'), 'checkbox')">
                                        <InputSelect
                                                v-model="dataProducts[productIndex].data.participant.teamId"
                                                :options="dataSelectOptions.teamId"
                                                :label="Core.Definition.getDefinition('Équipe')">
                                        </InputSelect>
                                    </b-col>
                                    <b-col v-show="Core.Value.encode(Core.Session.Setting.getSetting('commerce.product.participantCategoryIsEnabled'), 'checkbox')">
                                        <InputSelect
                                                v-model="dataProducts[productIndex].data.participant.participantCategoryId"
                                                :options="dataSelectOptions.participantCategoryId"
                                                :label="Core.Definition.getDefinition('Catégorie')">
                                        </InputSelect>
                                    </b-col>
                                </b-row>

                                <b-row v-if="Core.Value.encode(Core.Setting.getSetting('commerce.product.tshirtIsEnabled'), 'checkbox')">
                                    <b-col>
                                        <InputSelect
                                                v-model="dataProducts[productIndex].data.participant.tshirtSize"
                                                :options="dataSelectOptions.tshirtSize"
                                                :label="Core.Definition.getDefinition('T-Shirt: Taille')">
                                        </InputSelect>
                                    </b-col>
                                    <b-col>
                                        <InputText
                                                v-model="dataProducts[productIndex].data.participant.tshirtCustomName"
                                                v-if="Core.Value.encode(product.instance.tshirtCustomNameIsEnabled, 'checkbox')"
                                                :label="Core.Definition.getDefinition('T-Shirt: Nom personnalisé')">
                                        </InputText>
                                    </b-col>
                                </b-row>

                            </b-collapse>
                        </td>
                    </tr>
                    <tr v-if="Core.Product.conditionalIsEnabled(product.instance)">
                        <td style="border-top: none" colspan="7">
                                <b-collapse :id="'collapseConditionalIsEnabled' + productIndex" class="mt-2">

                                    <b-row>
                                        <b-col>
                                            <InputSelect
                                                    v-model="dataProducts[productIndex].data.conditional.seasonId"
                                                    :options="dataSelectOptions.seasonId"
                                                    :label="Core.Definition.getDefinition('Saison')">
                                            </InputSelect>
                                        </b-col>
                                        <b-col>
                                            <InputSelect
                                                    v-model="dataProducts[productIndex].data.conditional.leagueId"
                                                    :options="dataSelectOptions.leagueId"
                                                    :label="Core.Definition.getDefinition('Ligue')">
                                            </InputSelect>
                                        </b-col>
                                        <b-col>
                                            <InputSelect
                                                    v-model="dataProducts[productIndex].data.conditional.districtId"
                                                    :options="dataSelectOptions.districtId"
                                                    :label="Core.Definition.getDefinition('Région')">
                                            </InputSelect>
                                        </b-col>
                                    </b-row>
                                    <hr/>
                                    <b-row>
                                        <b-col class="text-right">
                                            <b-link @click="onAddEventDateClick(productIndex)"  href="#" class="card-header-action btn-setting">
                                                <i class="fa fa-plus"></i>&nbsp;{{Core.Definition.getDefinition('Date')}}
                                            </b-link>
                                        </b-col>
                                    </b-row>
                                    <table :class="{ 'table-responsive': Core.Display.isMobile() }" class="table table-striped">
                                        <thead>
                                            <th>
                                                {{Core.Definition.getDefinition('Date')}}
                                            </th>
                                            <th>
                                                {{Core.Definition.getDefinition('Événement')}}
                                            </th>
                                            <th>
                                            </th>
                                        </thead>
                                        <tbody>
                                            <tr v-if="dataProducts[productIndex].data.conditional !== false" :key="eventDateIndex" v-for="eventDate, eventDateIndex in dataProducts[productIndex].data.conditional.eventDateId">
                                                <td>{{eventDate.start}}</td>
                                                <td>{{eventDate.title}}</td>
                                                <td>
                                                    <b-button @click="onRemoveEventDateClick(productIndex, eventDateIndex)" class="btn btn-sm btn-danger">
                                                        <i class="fa fa-trash-o"></i>
                                                    </b-button>
                                                </td>
                                            </tr>
                                            <tr v-if="dataProducts[productIndex].data.conditional === false || dataProducts[productIndex].data.conditional.eventDateId === null ||dataProducts[productIndex].data.conditional.eventDateId.length === 0">
                                                <td colspan="3">
                                                    {{Core.Definition.getDefinition('Aucune date')}}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </b-collapse>

                            <ModalInstanceSelector
                                    :caption="Core.Definition.getDefinition('Choix de l\'événement')"
                                    :ref="'modalInstanceSelectorEventDate' + productIndex"
                                    root="/event-date/list"
                                    :multiple="false"
                                    @onAdd="onAddEventDate"
                                    :searchFormStructure="{
                                      rows: [
                                            {
                                                cols: [
                                                    {
                                                        fields: [
                                                            {
                                                                id: 'start'
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        fields: [
                                                            {
                                                                id: 'eventId'
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                     ],
                                     fields: [
                                            {
                                                id: 'start',
                                                type: 'datePicker',
                                                isInline: false,
                                                label: Core.Definition.getDefinition('Date'),
                                                value: null,
                                                onChange: function() {}
                                            },
                                            {
                                                id: 'eventId',
                                                type: 'select',
                                                label: Core.Definition.getDefinition('Événement'),
                                                value: null,
                                                onSelect: function() {}
                                            }
                                      ]
                                 }"
                                    :options="{
                                        pagination: true,
                                        header: true,
                                        responsive: false,
                                        striped: true,
                                        headerStyle: '1',
                                        emptyText: Core.Definition.getDefinition('Aucune date à afficher'),
                                        borderVariant: 'white',
                                        noBody: true
                                 }"
                                    :columns="[
                                {
                                    label: Core.Definition.getDefinition('Date'),
                                    key: 'start',
                                    type: 'date',
                                    format: 'DD MMM YYYY HH:mm',
                                    sortable: true
                                },
                                {
                                    label: Core.Definition.getDefinition('Titre'),
                                    key: 'title',
                                    sortable: true
                                }
                         ]"></ModalInstanceSelector>
                        </td>
                    </tr>
                </template>

            </tbody>
            <tfoot>
                <tr>
                    <td colspan="3">
                    </td>
                    <td colspan="2">
                        <InputPromoCode
                                ref="promoCode"
                                v-model="dataPromoCode"
                                :placeHolder="Core.Definition.getDefinition('Code promo')"
                                root="/promo-code/validate">
                        </InputPromoCode>
                    </td>
                    <td></td>
                </tr>
                <tr>
                    <td class="text-right" colspan="4">
                        <b>{{Core.Definition.getDefinition('Sous-total')}}</b>
                    </td>
                    <td>
                        {{Core.Currency.format(dataSubTotal)}}
                    </td>
                    <td width="100px"></td>
                    <td width="50px"></td>
                </tr>
                <tr v-for="tax in dataTaxes">
                    <td class="text-right" colspan="4">
                        <b>{{tax.label}}</b>
                    </td>
                    <td>
                        {{Core.Currency.format(tax.total)}}
                    </td>
                    <td width="100px"></td>
                    <td width="50px"></td>
                </tr>
                <tr>
                    <td class="text-right" colspan="4">
                        <b>{{Core.Definition.getDefinition('Total')}}</b>
                    </td>
                    <td>
                        {{Core.Currency.format(dataTotal)}}
                    </td>
                    <td width="100px"></td>
                    <td width="50px"></td>
                </tr>
            </tfoot>
        </table>

    </div>
</template>

<script>
    import InputQuantity from './InputQuantity'
    import InputCurrency from './InputCurrency'
    import InputText from './InputText'
    import InputSelect from './InputSelect'
    import InputMultiSelect from './InputMultiSelect'
    import InputPhone from './InputPhone'
    import InputDatePicker from './InputDatePicker'
    import InputPromoCode from './InputPromoCode'
    import ModalInstanceSelector from './ModalInstanceSelector'

    export default {
        name: 'ProductSummary',
        components: {
            InputQuantity,
            InputCurrency,
            InputText,
            InputSelect,
            InputPhone,
            InputDatePicker,
            InputMultiSelect,
            ModalInstanceSelector,
            InputPromoCode
        },
        props: {
            id: {
                type: String,
                default: ''
            },
            form: {
                type: Object,
                default: function () {
                    return {}
                }
            },
            fieldRefs: {
                type: Array,
                default: function () {
                    return []
                }
            },
            value: {
                type: Array,
                default: function () {
                    return []
                }
            },
            quantityStep: {
                type: Number | String,
                default: 1
            },
            evalFromQuantity: {
                type: Boolean,
                default: true
            }
        },
        watch: {
            value: {
                handler(val) {
                    this.dataProducts = val
                    this.eval()
                },
                deep:true
            },
            dataProducts: {
                handler(val) {
                    this.$emit('input', val)
                },
                deep: true
            },
            dataPromoCode: {
                handler(val) {
                    this.eval()
                }
            }
        },
        computed: {
            teamId: {
                get() {
                    return this.dataSelectOptions.teamId
                },
                set(val) {
                    this.dataSelectOptions.teamId = val
                }
            },
            participantCategoryId: {
                get() {
                    return this.dataSelectOptions.participantCategoryId
                },
                set(val) {
                    this.dataSelectOptions.participantCategoryId = val
                }
            },
            tshirtSize: {
                get() {
                    return this.dataSelectOptions.tshirtSize
                },
                set(val) {
                    this.dataSelectOptions.tshirtSize = val
                }
            },
            seasonId: {
                get() {
                    return this.dataSelectOptions.seasonId
                },
                set(val) {
                    this.dataSelectOptions.seasonId = val
                }
            },
            districtId: {
                get() {
                    return this.dataSelectOptions.districtId
                },
                set(val) {
                    this.dataSelectOptions.districtId = val
                }
            },
            leagueId: {
                get() {
                    return this.dataSelectOptions.leagueId
                },
                set(val) {
                    this.dataSelectOptions.leagueId = val
                }
            }
        },
        mounted() {
            this.dataProducts = this.value
        },
        data: () => {
            return {
                Core: window.Core,
                dataProducts: [],
                dataSubTotal: 0,
                dataTotal: 0,
                dataTrashModal: {
                    show: false,
                    index: ''
                },
                dataQuantityStep: 1,
                dataTaxes: [],
                dataSelectOptions: {
                    teamId: [],
                    participantCategoryId: [],
                    tshirtSize: [],
                    leagueId: [],
                    districtId: [],
                    seasonId: []
                },
                dataProductIndex: '',
                dataPromoCode: {}

            }
        },
        methods: {
            onAddEventDateClick(productIndex) {
                this.dataProductIndex = productIndex
                this.$refs['modalInstanceSelectorEventDate' + productIndex][0].open = true
            },
            onAddEventDate(row, data) {
                if (Array.isArray(this.dataProducts[this.dataProductIndex].data.conditional.eventDateId)==false) {
                    this.dataProducts[this.dataProductIndex].data.conditional.eventDateId = []
                }
                this.dataProducts[this.dataProductIndex].data.conditional.eventDateId.push({
                    id: row.id,
                    start: row.start,
                    title: row.title
                })
            },
            onRemoveEventDateClick(productIndex, eventDateIndex) {
                this.dataProducts[productIndex].data.conditional.eventDateId.splice(eventDateIndex, 1)
            },
            addProduct(id, title, description, price, isTaxable, quantity) {

                let taxes = Core.Session.Setting.getTaxes()

                if (quantity === undefined) {
                    quantity = 1
                }
                this.dataProducts.push(
                    {
                        id: id,
                        title: title,
                        description: description,
                        price: price,
                        isTaxable: isTaxable,
                        total: 0,
                        subTotal: 0,
                        quantity: quantity,
                        taxes: taxes,
                        taxesTotal: 0,
                        data: {}
                    }
                )
                this.eval()
            },
            eval() {
                this.dataQuantityStep = this.quantityStep
                this.dataSubTotal = 0
                this.dataTotal = 0

                let taxes = Core.Session.Setting.getTaxes()
                this.dataTaxes = taxes
                for(let taxIndex in this.dataTaxes) {
                    this.dataTaxes[taxIndex].total = 0
                }

                for(let productIndex in this.dataProducts) {

                    if (isNaN(this.dataQuantityStep)) {
                        if (this.dataProducts[productIndex].instance[this.dataQuantityStep] !== undefined && !isNaN(this.dataProducts[productIndex].instance[this.dataQuantityStep])) {
                            this.dataQuantityStep = this.dataProducts[productIndex].instance[this.dataQuantityStep]
                        }
                    }

                    if (this.dataProducts[productIndex].instance.regularPrice !== undefined) {

                        this.dataProducts[productIndex].instance.regularPrice = this.dataProducts[productIndex].instance.regularPrice.replace(',', '.')

                        if (this.dataProducts[productIndex].quantity!==undefined) {
                            if (isNaN(this.dataProducts[productIndex].quantity)) {
                                this.dataProducts[productIndex].quantity = this.dataQuantityStep
                            }

                            if (this.dataProducts[productIndex].taxes === undefined) {
                                this.dataProducts[productIndex].taxes = taxes
                            }

                            let subTotal = 0
                            if (this.evalFromQuantity) {
                                subTotal = (this.dataProducts[productIndex].instance.regularPrice * this.dataProducts[productIndex].quantity) / this.dataQuantityStep
                            } else {
                                subTotal = this.dataProducts[productIndex].instance.regularPrice * 1
                            }

                            let deductible = Core.PromoCode.getDeductible(this.dataPromoCode, this.dataProducts[productIndex].instance.id, subTotal)
                            if (deductible) {
                                this.dataProducts[productIndex].data.promoCode = {
                                    code: this.dataPromoCode.code,
                                    id: this.dataPromoCode.instance.id,
                                    deductible: deductible
                                }
                            }

                            if (this.dataProducts[productIndex].data !== undefined && this.dataProducts[productIndex].data.promoCode !==undefined&&this.dataProducts[productIndex].data.promoCode.deductible !==undefined) {
                                subTotal -= this.dataProducts[productIndex].data.promoCode.deductible
                            }

                            let productTaxesTotal = 0
                            if (this.dataProducts[productIndex].instance.isTaxable!==undefined&&this.dataProducts[productIndex].instance.isTaxable == true) {
                                if (taxes) {
                                    for(let taxIndex in taxes) {
                                        let tax = taxes[taxIndex]
                                        productTaxesTotal += Core.Taxes.total(subTotal, tax)
                                        if (undefined === this.dataTaxes[taxIndex].total) {
                                            this.dataTaxes[taxIndex].total = 0
                                        }
                                        this.dataTaxes[taxIndex].total += Core.Taxes.total(subTotal, tax)
                                    }
                                }
                            }
                            this.dataProducts[productIndex].taxesTotal = productTaxesTotal

                            let total = subTotal + productTaxesTotal

                            this.dataProducts[productIndex].total = subTotal
                            this.dataSubTotal += subTotal
                            this.dataTotal += total

                        }
                    }
                }

                this.$emit('updateTotal', this.dataSubTotal, this.dataTotal, this.form, this.fieldRefs, this.dataProducts, this.dataDeductibles)
            },
            onTrashClick(productIndex) {
                this.dataProducts.splice(productIndex, 1)
                this.eval()
            },
            onMinus(product) {
                this.$emit('onMinus', product, this.form, this.fieldRefs)
            },
            onPlus(product) {
                this.$emit('onPlus', product, this.form, this.fieldRefs)
            }
        }
    }
</script>
